import React from 'react';
import PropTypes from 'prop-types';

const Twitter = ({
	fill = '#9b9b9b',
	...props
}) => (
	<svg width="24" height="20" viewBox="0 0 24 20" fill={fill} {...props}>
		<path d="M24,2.6 C23.1,3 22.2,3.3 21.2,3.4 C22.2,2.8 23,1.8 23.4,0.7 C22.4,1.3 21.4,1.7 20.3,1.9 C19.4,0.9 18.1,0.3 16.7,0.3 C14,0.3 11.8,2.5 11.8,5.2 C11.8,5.6 11.8,6 11.9,6.3 C7.7,6.1 4.1,4.1 1.7,1.1 C1.2,1.9 1,2.7 1,3.6 C1,5.3 1.9,6.8 3.2,7.7 C2.4,7.7 1.6,7.5 1,7.1 C1,7.1 1,7.1 1,7.2 C1,9.6 2.7,11.6 4.9,12 C4.5,12.1 4.1,12.2 3.6,12.2 C3.3,12.2 3,12.2 2.7,12.1 C3.3,14.1 5.1,15.5 7.3,15.5 C5.6,16.8 3.5,17.6 1.2,17.6 C0.8,17.6 0.4,17.6 1.8e-15,17.5 C2.2,18.9 4.8,19.7 7.5,19.7 C16.6,19.7 21.5,12.2 21.5,5.7 C21.5,5.5 21.5,5.3 21.5,5.1 C22.5,4.4 23.3,3.5 24,2.6 Z"/>
	</svg>
);

Twitter.propTypes = {
	fill: PropTypes.string
};

export default Twitter;
